<div class="pt-sm-3" style="width:100%; padding-right:0px">


    <div class="main">
        <div class="header">
            <!-- Menu button enables for small screen (mobile) -->
            <div class="me-4 d-block d-md-none">
                <i class="fa fa-bars" (click)="showSideBarMenu()" style="font-size: 28px;" aria-hidden="true"></i>
            </div>
<div class="row">
            <div class="col-md-9" style="font-size: 20px; font-weight:600; font-family:Raleway;">Dashboard</div>
            <div class="col-md-3 d-flex justify-content-end">
            <div (click)="showFilter = !showFilter" class="filterTextContainer">
                <img src="assets/images/filterIcon.svg" alt="Download Icon"
                   />
                <span>Filters</span>
            </div>
            <!-- <div class="downloadContainer ms-2" >
                <app-download-csv [apiEndPoint]="csvDownloadAPI" filterParams="fromDashboard=true"
                    [fileName]="csvFileName"></app-download-csv>
            </div> -->
            <div class="downloadContainer ms-2" matTooltip="Card data only">
                <app-download-csv [apiEndPoint]="csvDownloadAPI" filterParams="fromDashboard=true"
                    [fileName]="csvFileName"></app-download-csv>
            </div>
            </div>
        </div>
        </div>

        <div class="tableContainer">
            <div class="row" style="margin: 0;">
                <div class="col-md-12">
                    <div class="col-12 mb-3">
                        <div class="filter-labels">
                            <span class="filter-label me-3" *ngIf="startDate !== ''"><span class="dark-label">From:</span> {{ startDate | date: 'dd/MM/yyyy' }} </span>
                            <span class="filter-label me-3" *ngIf="endDate !== ''"><span class="dark-label">To:</span> {{ endDate | date: 'dd/MM/yyyy' }} </span>
                            <span class="filter-label me-3" *ngIf="cseName !== ''"><span class="dark-label">QI Provider:</span> {{ cseName }} </span>
                            <span class="filter-label me-3" *ngIf="state_name !== ''"><span class="dark-label">State:</span> {{ state_name }} </span>
                        </div>
                    </div>
                    <div *ngIf="showFilter" class="row shadow p-3" style="background: white;">
                        <!-- <div class="filterBoxHeader">
                            <div>Filter</div>
                            <i (click)="showFilter = false" class="fa fa-times" aria-hidden="true"></i>
                            style="width: 18.499999995%;
                            flex: 0 0 18.499%;max-width: 18.499%;"'/:::::::::::::::::::::::::'
                        </div> -->
                       
                        

                        <div class="col-sm-12 col-md-2 col-lg-2 col-xl-2">
                            <mat-form-field class="w-100" appearance="outline" color="accent">
                              <mat-label>From</mat-label>
                              <input [(ngModel)]="startDate" matInput [matDatepicker]="startDatePicker" name="startDate">
                              <mat-datepicker-toggle matSuffix [for]="startDatePicker"></mat-datepicker-toggle>
                              <mat-datepicker #startDatePicker></mat-datepicker>
                            </mat-form-field>
                          </div>
                          
                          <div class="col-sm-12 col-md-2 col-lg-2 col-xl-2">
                            <mat-form-field class="w-100" appearance="outline" color="accent">
                              <mat-label>To</mat-label>
                              <input [(ngModel)]="endDate" matInput [matDatepicker]="endDatePicker" name="endDate">
                              <mat-datepicker-toggle matSuffix [for]="endDatePicker"></mat-datepicker-toggle>
                              <mat-datepicker #endDatePicker></mat-datepicker>
                            </mat-form-field>
                          </div>

                            <div class="col-sm-12 col-md-2 col-lg-2 col-xl-2">
                                <mat-form-field appearance="outline" class="w-100 custom-mat-form-field" color="accent">
                                    <mat-label>Select QI Provider</mat-label>
                                    <mat-select [(ngModel)]="cse_name" panelClass="custom-select-panel" (selectionChange)="conditionInputValue($event.value)">
                                        <input (input)="searchOnDropdown($event.target.value,'cse_name')" placeholder="Seach QI Provider"
                                        class="search-input">
                                        <mat-option *ngFor="let facility of originalFacilityList"
                                            [value]="facility.cseId">
                                            {{ facility.cse_name }}
                                        </mat-option>
                                        <mat-option *ngIf="originalFacilityList.length === 0" [disabled]="true">
                                            No data found
                                          </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>

                            <div class="col-sm-12 col-md-2 col-lg-2 col-xl-2">
                                <mat-form-field appearance="outline" class="w-100 custom-mat-form-field" color="accent">
                                    <mat-label>Select State</mat-label>
                                    <mat-select [(ngModel)]="state_name" panelClass="custom-select-panel">
                                        <input (input)="searchOnDropdown($event.target.value,'state_name')" placeholder="Seach State"
                                        class="search-input">
                                        <mat-option *ngFor="let state of originalStateList"
                                            [value]="state.state_name">
                                            {{ state.state_name }}
                                        </mat-option>
                                        <mat-option *ngIf="originalStateList.length === 0" [disabled]="true">
                                            No data found
                                          </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>

                       
                        <div class="col-sm-12 col-md-3 col-lg-3 col-xl-3">

                                <button mat-flat-button color="accent"
                                [disabled]="!(startDate !== '' && endDate !== '') && (cse_name === '' || cse_name === undefined) && (state_name === '' || state_name === undefined)"
                                (click)="applyClick()" class="randomize mt-1 mb-2">Apply</button>
                           
                            <button class="ms-2 mt-1 mb-2" mat-flat-button color="primary"
                            [disabled]="!(startDate !== '' && endDate !== '')  && (cse_name === '' || cse_name === undefined) && (state_name === '' || state_name === undefined)"
                            (click)="reset()">Reset</button>
                           
                        </div>
                    </div>
                </div>
            </div>

            <div class="container-fluid mt-3">
                <div class="operations-dashboard mb-3">
                    <h6 class="textColor">Operations Dashboard</h6>
                </div>
                <!-- Cards -->
                <div class="row">
                    <!--Operations Dashboard-->
                    <div class="col-lg-7">
                        <div class="row">
                            
                      
                            <div class="col-lg-4 col-sm-6 mb-3" *ngFor="let card of cardList; let index=index;">
                                
                                <div [matTooltip]="card.tooltipText" matTooltipPosition="above" class="card {{ card.gradientClass }} shadow gradient-cards">
                                    
                                    <div class="d-flex justify-content-between">
                                        <div class="me-2" style="font-size: 14px; font-weight:600;">{{card?.header}}</div>
                                    </div>
                                        <div class="cardHeader pt-2">
                                    <div class="cardContent">
                                        {{card?.data}}
                                    </div>
                                     <!-- Card Icons -->
                                     <div class="iconContainer">
                                        <svg *ngIf="card?.header == 'Registration Initiated' || card?.header == 'Facilities in Pipeline'"  style="padding:2px;" id="Group_16612" data-name="Group 16612" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                                            <path id="Path_6347" data-name="Path 6347" d="M0,0H24V24H0Z" fill="none"/>
                                            <path id="Path_6348" data-name="Path 6348" d="M15,4H5V20H19V8H15ZM3,2.992A1,1,0,0,1,4,2H16l5,5V20.993A1,1,0,0,1,20.007,22H3.993A1,1,0,0,1,3,21.008ZM11,11V8h2v3h3v2H13v3H11V13H8V11Z" fill="#7BAFD4"/>
                                          </svg>
                                          <svg *ngIf="card?.header == 'Registration Completed'" style="padding:2px;" id="Group_16795" data-name="Group 16795" xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 24 24">
                                            <path id="Path_6955" data-name="Path 6955" d="M0,0H24V24H0Z" fill="none"/>
                                            <path id="Path_6956" data-name="Path 6956" d="M12,22A10,10,0,1,1,22,12,10,10,0,0,1,12,22Zm0-2a8,8,0,1,0-8-8A8,8,0,0,0,12,20Zm-1-4L6.76,11.757l1.414-1.414L11,13.172l5.656-5.657,1.415,1.414Z" fill="#FF94B7"/>
                                          </svg>
                                          <svg  *ngIf="card?.header == 'Payment Completed'" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="M549-120 280-400v-80h140q53 0 91.5-34.5T558-600H240v-80h306q-17-35-50.5-57.5T420-760H240v-80h480v80H590q14 17 25 37t17 43h88v80h-81q-8 85-70 142.5T420-400h-29l269 280H549Z" fill="#9ACB99"/></svg>
                                          <svg  *ngIf="card?.header == 'Facilities Undergoing QI'" id="user-outlined" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                                            <rect id="Rectangle_3949" data-name="Rectangle 3949" width="24" height="24" fill="rgba(255,255,255,0)"/>
                                            <path id="Path_7185" data-name="Path 7185" d="M152.806,129.113a8.786,8.786,0,0,0-4.655-4.655l-.028-.012a5.768,5.768,0,1,0-6.756,0l-.028.012A8.744,8.744,0,0,0,136,132.328a.186.186,0,0,0,.186.191h1.4a.186.186,0,0,0,.186-.181,6.982,6.982,0,0,1,13.959,0,.184.184,0,0,0,.186.181h1.4a.186.186,0,0,0,.186-.191A8.669,8.669,0,0,0,152.806,129.113Zm-8.061-5.342a4,4,0,1,1,2.829-1.173A3.976,3.976,0,0,1,144.745,123.771Z" transform="translate(-132.834 -111.348)" fill="#ff6b6b"/>
                                          </svg>
                                          <svg *ngIf="card?.header == 'Facilities Ready for QA' || card?.header == 'Facilties Registered Under Momentum Scheme'" id="document" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                                            <rect id="Rectangle_3950" data-name="Rectangle 3950" width="24" height="24" fill="rgba(255,255,255,0)"/>
                                            <g id="feDocument0">
                                              <g id="feDocument1">
                                                <path id="feDocument2" d="M15,4H6V20H18V7H15ZM6,2H16l4,4V20a2,2,0,0,1-2,2H6a2,2,0,0,1-2-2V4A2,2,0,0,1,6,2Zm2,9h8v2H8Zm0,4h8v2H8Z" fill="#d1a0e4"/>
                                              </g>
                                            </g>
                                          </svg>
                                          
                                          <svg *ngIf="card?.header == 'Facilities Certified'" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                                            <g id="user-certification" transform="translate(0.156 0.156)">
                                              <rect id="Rectangle_3951" data-name="Rectangle 3951" width="24" height="24" transform="translate(-0.156 -0.156)" fill="rgba(255,255,255,0)"/>
                                              <path id="Path_7186" data-name="Path 7186" d="M19.138,7.961,20.325,10.2l2.539.308L21,12.184l.373,2.483-2.235-1.4-2.235,1.4.373-2.483L15.412,10.5,18.02,10.2ZM16.9,22.863h-1.49V19.138a3.73,3.73,0,0,0-3.726-3.726H7.216A3.73,3.73,0,0,0,3.49,19.138v3.726H2V19.138a5.222,5.222,0,0,1,5.216-5.216h4.471A5.222,5.222,0,0,1,16.9,19.138ZM9.451,3.49A3.726,3.726,0,1,1,5.726,7.216,3.726,3.726,0,0,1,9.451,3.49m0-1.49a5.216,5.216,0,1,0,5.216,5.216A5.216,5.216,0,0,0,9.451,2Z" transform="translate(-0.51 -0.51)" fill="#72ddd6"/>
                                            </g>
                                          </svg>
                                          
                                    </div>
                                    </div>
                                </div>
                            </div>  
                        </div> 
                        <div class="row">
                            <div class="col-md-12 mt-2 mb-1">
                                    <div class="card_chart_wrapper shadow mb-1 rounded-3" style="background: white;">
                                        <div class="d-flex align-items-center justify-content-between mb-3">
                                            <div class="title-heading"  matTooltip="This bar chart highlights the top 5 CSEs linked to the highest number of facilities." matTooltipPosition="above">Leading QI Providers in Facility Registrations</div>
                                            <div class="sort-btn">
                                                <div>
                                                    <i class="fa fa-cloud-download mx-2" aria-hidden="true" style="color:#EC054A;
                                                cursor: pointer;font-size: 22px;" matTooltip="Download"
                                                        (click)="downloadChart('facilities_in_pipline','Leading QI Providers in Facility Registrations')"></i>
                
                                                </div>
                                            </div>
                                        </div>
                
                                        <div *ngIf="qiProvidersData" id="facilities_in_pipline">
                                            <canvas #barChartCanvas height="245"></canvas>
                                        </div>

                                        <div *ngIf="!qiProvidersData">
                                            <div style="display: flex; flex-direction:column; align-items:center;justify-content: center;">
                                                <!-- No Data Found -->
                                                <img src="assets/images/no-data-found.svg" alt="No Data Found" width="150px"
                                                    height="150px">
                                                <div class="noData">No Data Found</div>
                                            </div>
                                        </div>
                
                                    </div>
                            </div>
                        </div>
                      

                    </div>
                    <!--Geographical Reach ( Registration Initiated )-->
                    <div class="col-lg-5 col-sm-12 map-card">
                        <h5 *ngIf="stateData" class="p-3" style="background: white;margin-bottom: -8px; border-radius: 8px 8px 0 0;box-shadow: 1px 0px 2px 3px rgba(121, 121, 121, 0.15);">Geographical Reach ( Registration Initiated )</h5>
                        <!-- <div> -->
                            <app-map style="z-index: 1;" [mapData]="mapData" [mapStateData]="stateData"
                            [mapDistrictData]="districtData" (stateClick)="getDistrictData($event)"></app-map>
                        <!-- </div> -->

                     
                       
                    </div>
                 
                </div>

            </div>
        </div>


        <div class="tableContainer">
         
            <div class="row" style="padding: 9px;">
                <!--Facilities Registered by Bed Size-->
                <div class="col-lg-7 mb-lg-0 my-2">
                    <div class="card_chart_wrapper shadow mb-1 rounded-3 h-100 position-relative" style="background: white;">
                        <div class="d-flex align-items-center justify-content-between mb-3">
                            <div class="title-heading" matTooltip="This chart illustrates the breakdown of facilities that have completed their payments, categorized by bed size." matTooltipPosition="above">Facilities Registered by Bed Size</div>
                            <div class="sort-btn">
                                <div>
            
                                    <i class="fa fa-cloud-download mx-2" aria-hidden="true" style="color:#EC054A;
                                cursor: pointer;font-size: 22px;" matTooltip="Download"
                                        (click)="downloadChart('facilities_registered_by_bed_size','Facilities Registered by Bed Size')"></i>
            
                                </div>
                            </div>
                        </div>
            
                        <div *ngIf="facilitiesBedSizeData" id="facilities_registered_by_bed_size">
                            <!-- <canvas #doughnutChart id="doughnutChart"></canvas> -->
                            <svg id="mjm" preserveAspectRatio="xminymin meet"></svg>
                        </div>
                        <div *ngIf="!facilitiesBedSizeData">
                            <div style="display: flex; flex-direction:column; align-items:center;">
                                <img src="assets/images/no-data-found.svg" alt="No Data Found" width="150px" height="150px">
                                <div class="noData">No Data Found</div>
                            </div>
                        </div>
            
                    </div>
                </div>
                <!--Facilities Registered by QI Providers-->
                <div class="col-lg-5 mb-lg-0 my-2">
                    <div class="card card_chart_wrapper shadow mb-1 rounded-3 h-100">
                        <div class="d-flex align-items-center justify-content-between mb-3">
                            <div class="title-heading" matTooltip="The table presents QI providers and the number of facilities linked to them." matTooltipPosition="above">Facilities Registered by QI Providers</div>
                            <div class="sort-btn">
                                <i class="fa fa-cloud-download mx-2" aria-hidden="true" style="color:#EC054A;
                            cursor: pointer;font-size: 22px;" matTooltip="Download" (click)="downloadCSV()"></i>

                            </div>
                        </div>

                        <div class="table-container" style="height: 360px;">
                            <table class="table">
                                <thead class="thead-dark" style="background: #FFCFDE;">
                                    <tr>
                                        <th style="width: 240px;" *ngFor="let columnObj of columnList" scope="col"
                                            (click)="sortTable(columnObj.key,'cse')">{{columnObj.name}}
                                            <i class="fa" style="cursor: pointer;" [ngClass]="{
                                            'fa-sort': currentSortColumn !== columnObj.key,
                                            'fa-sort-asc': currentSortColumn === columnObj.key && isAscending,
                                            'fa-sort-desc': currentSortColumn === columnObj.key && !isAscending
                                        }"></i>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody class="total">
                                    <tr class="selectedRow" *ngFor="let obj of sortedTableData; let index=index">
                                        <td>{{obj.cse_name}}</td>
                                        <td>{{obj.userCount}}</td>
                                    </tr>
                                    <tr>
                                        <td>Total</td>
                                        <td>{{grandTotal}}</td>
                                    </tr>
                                </tbody>

                            </table>
                            <div *ngIf="sortedTableData.length == 0">
                                <div style="display: flex; flex-direction:column; align-items:center;">
                                    <!-- No Data Found -->
                                    <img src="assets/images/no-data-found.svg" alt="No Data Found" width="150px"
                                        height="150px">
                                    <div class="noData">No Data Found</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

               
            </div>
           

            <div class="row">
                <div class="col-md-6 mt-2 mb-1">
                        <div class="card_chart_wrapper shadow mb-1 rounded-3" style="background: white;">
                            <div class="d-flex align-items-center justify-content-between mb-3">
                                <div class="title-heading" matTooltipPosition="above">Average time taken by QI providers to make facility QA reddy</div>
                                <div class="sort-btn">
                                    <div>
                                        <i class="fa fa-cloud-download mx-2" aria-hidden="true" style="color:#EC054A;
                                    cursor: pointer;font-size: 22px;" matTooltip="Download"
                                            (click)="downloadChart('horizotalChartCanvas ','Average time taken by QI providers to make facility QA reddy')"></i>
    
                                    </div>
                                </div>
                            </div>
    
                            <div *ngIf="qiProvidersData" id="horizotalChartCanvas ">
                                <canvas #horizotalChartCanvas height="355"></canvas>
                            </div>

                            <div *ngIf="!qiProvidersData">
                                <div style="display: flex; flex-direction:column; align-items:center;justify-content: center;">
                                    <!-- No Data Found -->
                                    <img src="assets/images/no-data-found.svg" alt="No Data Found" width="150px"
                                        height="150px">
                                    <div class="noData">No Data Found</div>
                                </div>
                            </div>
    
                        </div>
                </div>

                <div class="col-md-6 mt-2 mb-1">
                    <div class="card_chart_wrapper shadow mb-1 rounded-3" style="background: white;">
                        <div class="d-flex align-items-center justify-content-between mb-3">
                            <div class="title-heading" matTooltipPosition="above">Average time taken for a facility to get certified</div>
                            <div class="sort-btn">
                                <div>
                                    <i class="fa fa-cloud-download mx-2" aria-hidden="true" style="color:#EC054A;
                                cursor: pointer;font-size: 22px;" matTooltip="Download"
                                        (click)="downloadChart('horizotalSecondChartCanvas','Average time taken for a facility to get certified')"></i>

                                </div>
                            </div>
                        </div>

                        <div *ngIf="qiProvidersData" id="horizotalSecondChartCanvas">
                            <canvas #horizotalSecondChartCanvas height="355"></canvas>
                        </div>

                        <div *ngIf="!qiProvidersData">
                            <div style="display: flex; flex-direction:column; align-items:center;justify-content: center;">
                                <!-- No Data Found -->
                                <img src="assets/images/no-data-found.svg" alt="No Data Found" width="150px"
                                    height="150px">
                                <div class="noData">No Data Found</div>
                            </div>
                        </div>

                    </div>
            </div>
            </div>


        </div>

        
        <div class="row" style="padding: 9px;">
            <!--Facilities Registered by Bed Size-->
            <div class="col-lg-6 mb-lg-0 my-2">
                <div class="card_chart_wrapper shadow mb-1 rounded-3 h-100 position-relative" style="background: white;">
                    <div class="d-flex align-items-center justify-content-between mb-3">
                        <div class="title-heading" matTooltip="This chart illustrates the breakdown of facilities that have completed their payments, categorized by bed size." matTooltipPosition="above">Pipeline Facilities source</div>
                        <div class="sort-btn">
                            <div>
        
                                <i class="fa fa-cloud-download mx-2" aria-hidden="true" style="color:#EC054A;
                            cursor: pointer;font-size: 22px;" matTooltip="Download"
                                    (click)="downloadChart('pipeline_Facilities_source','Facilities Registered')"></i>
        
                            </div>
                        </div>
                    </div>
        
                    <div *ngIf="facilitiesBedSizeData" id="pipeline_Facilities_source">
                        <svg id="mjm1" preserveAspectRatio="xminymin meet"></svg>
                    </div>
                    <div *ngIf="!facilitiesBedSizeData">
                        <div style="display: flex; flex-direction:column; align-items:center;">
                            <img src="assets/images/no-data-found.svg" alt="No Data Found" width="150px" height="150px">
                            <div class="noData">No Data Found</div>
                        </div>
                    </div>
        
                </div>
            </div>

             <!--Facilities Registered by Bed Size-->
             <div class="col-lg-6 mb-lg-0 my-2">
                <div class="card_chart_wrapper shadow mb-1 rounded-3 h-100 position-relative" style="background: white;">
                    <div class="d-flex align-items-center justify-content-between mb-3">
                        <div class="title-heading" matTooltip="This chart illustrates the breakdown of facilities that have completed their payments, categorized by bed size." matTooltipPosition="above">Registration source</div>
                        <div class="sort-btn">
                            <div>
        
                                <i class="fa fa-cloud-download mx-2" aria-hidden="true" style="color:#EC054A;
                            cursor: pointer;font-size: 22px;" matTooltip="Download"
                                    (click)="downloadChart('registration_source','Registration source')"></i>
        
                            </div>
                        </div>
                    </div>
        
                    <div *ngIf="facilitiesBedSizeData" id="registration_source">
                        <svg id="registrationsource" preserveAspectRatio="xminymin meet"></svg>
                    </div>
                    <div *ngIf="!facilitiesBedSizeData">
                        <div style="display: flex; flex-direction:column; align-items:center;">
                            <img src="assets/images/no-data-found.svg" alt="No Data Found" width="150px" height="150px">
                            <div class="noData">No Data Found</div>
                        </div>
                    </div>
        
                </div>
            </div>


           
        </div>
         <!--Facilities Registered by Month-->
         <div class="row" style="padding: 9px;">
            <div class="col-xl-12 col-lg-12 col-sm-12 col-12 mt-2 mb-lg-0 mb-3">
              
                <div class="card card_chart_wrapper shadow mb-1 rounded-3">
                    
                     <div class="row justify-content-between">
                        <div class="col-md-auto title-heading" matTooltip="Current year by default. Adjust filters for specifics." matTooltipPosition="above">Facilities Registered by Month</div>
                        <div class="col-md-auto d-flex align-items-baseline text-end">
                            <!-- Dropdown for selecting the year -->
                            <mat-form-field class="w-100" appearance="outline">
                                <mat-label>Select Year</mat-label>
                                <mat-select [(ngModel)]="year_id" (selectionChange)="onYearSelectionChange($event)">
                                    <mat-option *ngFor="let year of years" [value]="year.id">{{ year.value }}</mat-option>
                                </mat-select>
                            </mat-form-field>
                            <i class="fa fa-cloud-download mx-2" aria-hidden="true" style="color:#EC054A; cursor: pointer; font-size: 22px;" matTooltip="Download" (click)="downloadChart('facilities_registered_by_month','Facilities Registered by Month')"></i>
                        </div>
                     </div>
                   
                    <div *ngIf="monthlyData" id="facilities_registered_by_month">
                        <canvas id="lineChart" width="200" height="280"></canvas>
                    </div>

                    <div *ngIf="!monthlyData">
                        <div style="display: flex; flex-direction:column; align-items:center;">
                            <!-- No Data Found -->
                            <img src="assets/images/no-data-found.svg" alt="No Data Found" width="150px"
                                height="150px">
                            <div class="noData">No Data Found</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>